import { useQuery } from "@tanstack/react-query";
import type { PartnerPanelStatus } from "@mfa-aff/shared";
import { panelStatusMock } from "../mocks/panel";
import { get } from "./client";
import { partnerPaths } from "./paths";

export const panelStatusKey = ["partner", "panel-status"] as const;

/**
 * `GET /status` (public): is the partner panel open, or closed by the owner (with the message to
 * show, and whether this browser is an allowlisted preview session). Polled, so a toggle in the
 * admin panel reaches open tabs within a minute (30 s while closed).
 */
export const usePanelStatus = () =>
    useQuery({
        queryKey: panelStatusKey,
        queryFn: () => get<PartnerPanelStatus>(partnerPaths.status, panelStatusMock),
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        refetchInterval: (q) => (q.state.data && !q.state.data.open ? 30_000 : 60_000),
    });
